// this file added by Bearer Web Developer
import React from "react";
import styles from './loading.module.scss';
import { useThemeMode } from "../../states/contexts/theme";

const Loading: React.FC = () => {

    const { theme } = useThemeMode(); // added by Bearer Web Developer
    return (
        <div className={styles?.loading} data-theme={theme}> {/* data-theme property added by Bearer Web Developer */}
            {
                theme === 'dark' ?
                    <img src="/bearer-header-logo-with-text-dark.webp" width="388" height="48" /> :
                    <img src="/bearer-business-logo.webp" alt="" width="388" height="48" />
            }
            <img className={styles?.light_bar} src="/animate-loading.svg" alt="" width="388" height="70" />
            <img className={styles?.dark_bar} src="/animate-loading-dark.svg" alt="" width="388" height="70" />
        </div>
    )
}
export default Loading;